import React from "react"
import { motion } from "framer-motion"
import { Sun, Moon } from "lucide-react"
import { useUIStore } from "../../store"

const ThemeToggle: React.FC = () => {
  const { theme, toggleTheme } = useUIStore()

  return (
    <motion.button
      onClick={toggleTheme}
      className="p-2 rounded-lg hover:bg-legacy-light/20 dark:hover:bg-legacy-dark/20 transition-colors duration-200"
      whileHover={{ scale: 1.05 }}
      whileTap={{ scale: 0.95 }}
      aria-label={`Switch to ${theme === "light" ? "dark" : "light"} mode`}
    >
      {theme === "light" ? (
        <Moon className="h-5 w-5 text-legacy-dark dark:text-legacy-cream" />
      ) : (
        <Sun className="h-5 w-5 text-legacy-dark dark:text-legacy-cream" />
      )}
    </motion.button>
  )
}

export default ThemeToggle
